import React from 'react'

import { Icon, Image, Header, Button, Dimmer, Form, Rating, RadioProps, CheckboxProps, Radio, Dropdown, Checkbox } from 'semantic-ui-react'

import blackBackground from '../../../_images/blackBackground.jpg'
import { IProject, ProjectQuestionResponse } from '../../../api/Data'

import CollectTabPhoneFrame from './CollectTabPhoneFrame'

const CollectTabCollectPagePreview = ({
  project,
  projectQuestions,
}: {
  project: IProject
  projectQuestions: ProjectQuestionResponse[]
}) => {
  const {
    displaySetting: { showLocation, showRating, ratingPrompt },
  } = project

  // #region Render Functions
  const wrapQuestionAsField = (question: ProjectQuestionResponse, element: JSX.Element) => (
    <Form.Field key={question.id} required>
      <label style={{ textAlign: 'center' }}>{question.text}</label>
      {element}
    </Form.Field>
  )

  const renderOptionsAsButtons = (
    questionId: number,
    options: string[],
    ButtonComponent: React.ComponentType<RadioProps | CheckboxProps>
  ) => (
    <div
      style={{
        marginTop: '10px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '15px',
      }}
    >
      {options.map((o) => (
        <div key={o} style={{ marginBottom: '10px' }}>
          <ButtonComponent label={o} name={`question_${questionId}`} value={o} />
        </div>
      ))}
    </div>
  )

  const renderOptionsAsList = (options: string[], isMultiSelect: boolean) => (
    <Dropdown
      placeholder={isMultiSelect ? 'Select options' : 'Select an option'}
      fluid
      selection
      search
      multiple={isMultiSelect}
      options={options.map((o) => ({ key: o, text: o, value: o }))}
      value={''}
    />
  )

  const renderFreeTextQuestion = (question: ProjectQuestionResponse) =>
    wrapQuestionAsField(
      question,
      <Form.TextArea placeholder="Type here..." name={question.id} rows={3} style={{ minHeight: '80px' }} />
    )

  const renderSelectQuestion = (question: ProjectQuestionResponse) => {
    if (!question.type.includes('Select'))
      return wrapQuestionAsField(
        question,
        <div style={{ color: 'red', textAlign: 'center' }}>Something went wrong rendering this question!</div>
      )

    const isMultiSelect = question.type === 'MultiSelect'
    const options = [...(question.options || []), ...(question.datasetKeys?.map((key) => key.value) || [])]

    if (!options.length) {
      return wrapQuestionAsField(
        question,
        <div style={{ color: 'red', textAlign: 'center' }}>
          {question.datasetId
            ? 'Save the questions to load the Dataset key values'
            : 'Add options manually or link a Dataset'}
        </div>
      )
    }

    const optionsComponent =
      options.length < 12
        ? renderOptionsAsButtons(question.id, options, isMultiSelect ? Checkbox : Radio)
        : renderOptionsAsList(options, isMultiSelect)

    return wrapQuestionAsField(question, optionsComponent)
  }

  const renderProjectQuestion = (question: ProjectQuestionResponse) => {
    switch (question.type) {
      case 'FreeText':
        return renderFreeTextQuestion(question)
      case 'SingleSelect':
      case 'MultiSelect':
        return renderSelectQuestion(question)
      default:
        return null
    }
  }
  // #endregion

  return (
    <>
      <CollectTabPhoneFrame project={project}>
        <>
          <Header as="h3" textAlign="center">
            Submit your video
            <Header.Subheader>Clip 1</Header.Subheader>
          </Header>
          {/* image */}
          <Dimmer.Dimmable>
            <Image src={blackBackground} rounded />
            <Dimmer active>
              <Icon name="play circle outline" size="huge" />
            </Dimmer>
          </Dimmer.Dimmable>
          <Form size="mini" style={{ marginTop: '1rem' }}>
            {/* show name */}
            <Form.Field required>
              <label style={{ textAlign: 'center' }}>Your name</label>
              <Form.Input placeholder="Type here..." />
            </Form.Field>

            {/* show location */}
            {showLocation && (
              <Form.Field required>
                <label style={{ textAlign: 'center' }}>Your location</label>
                <Form.Input placeholder="Type here..." />
              </Form.Field>
            )}

            {/* show rating */}
            {showRating && (
              <Form.Field required>
                <label style={{ textAlign: 'center' }}>{ratingPrompt}</label>
                <div style={{ margin: '1rem 0', textAlign: 'center' }}>
                  <Rating icon="star" defaultRating={4} maxRating={5} size="large" />
                </div>
              </Form.Field>
            )}

            {/* show questions */}
            {projectQuestions.map(renderProjectQuestion)}

            {/* cta */}
            <Button fluid compact size="mini" primary style={{ margin: '3rem auto' }}>
              Complete submission
            </Button>
          </Form>
        </>
      </CollectTabPhoneFrame>
    </>
  )
}

export default CollectTabCollectPagePreview
